import { __assign } from '../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import { useForm } from 'react-hook-form';
import { zodResolver as t } from '../../../../_externals/.pnpm/@hookform_resolvers@3.9.0_react-hook-form@7.53.0_react@18.3.1_/node_modules/@hookform/resolvers/zod/dist/zod.js';
import { Container } from './Container/Container.js';
import { TextInput } from './TextInput/TextInput.js';
import { CheckboxInput } from './CheckboxInput/CheckboxInput.js';
import { RadioInput } from './RadioInput/RadioInput.js';
import { SelectInput } from './SelectInput/SelectInput.js';

var createForm = function (schema) { return ({
    Container: (Container),
    TextInput: (TextInput),
    CheckboxInput: (CheckboxInput),
    RadioInput: (RadioInput),
    SelectInput: (SelectInput),
    useForm: function (props) {
        return useForm(__assign({ resolver: t(schema) }, props));
    },
}); };

export { createForm as default };
//# sourceMappingURL=index.js.map
